import { render } from "./UpdateItem.vue?vue&type=template&id=0ca5976b&scoped=true"
import script from "./UpdateItem.vue?vue&type=script&lang=js"
export * from "./UpdateItem.vue?vue&type=script&lang=js"

import "./UpdateItem.vue?vue&type=style&index=0&id=0ca5976b&lang=css&scoped=true"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca5976b"]])

export default __exports__